module.exports = __webpack_public_path__ + "static/img/1.025a6d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/1.png
// module id = tN8x
// module chunks = 0